<template>
    <div>
        <p>Mon compte</p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'MyAccountPage',
    methods: {
        
    },
});
</script>

<style scoped>

</style>
